exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-top-3-movies-js": () => import("./../../../src/pages/top3movies.js" /* webpackChunkName: "component---src-pages-top-3-movies-js" */)
}

